import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

import { ContextService } from 'src/core/services/context.service';

export class TaxonomyListDataService extends DataService<typeof Model.General.Logic.ViewModels.TaxonomySummary, Model.General.Logic.ViewModels.TaxonomySummary, TaxonomySummary> {
	protected map(entity: Model.General.Logic.ViewModels.TaxonomySummary): TaxonomySummary {
		return new TaxonomySummaryModel(entity);
	}

	static make(context?: ContextService): TaxonomyListDataService {
		return new TaxonomyListDataService(context, ctx => ctx.TaxonomySummaries);
	}
}

export class TaxonomySummaryModel extends EntityModel<Model.General.Logic.ViewModels.TaxonomySummary, TaxonomySummary> implements TaxonomySummary {
	@property<TaxonomySummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<TaxonomySummaryModel>(o => o.entity.jsonSchemaDefinitionName, (o, value) => o.entity.jsonSchemaDefinitionName = value)
	public jsonSchemaDefinitionName: string;

	@property<TaxonomySummaryModel>(o => o.entity.displayName, (o, value) => o.entity.displayName = value)
	public displayName: string;
}



// WEBPACK FOOTER //
// ./src/app/general/taxonomies/list/taxonomy-list.data.ts